import { ParticipantData } from "./ParticipantData.js";

export class ParticipantsLink {
  constructor() {
    this.participants = [];
  }

  async request() {
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          "bk-working": "participants",
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.receiveJSON(data);
      return this;
    } catch (error) {
      console.error("ParticipantsLink request failed:", error);
      throw error;
    }
  }

  async updateAttendance(playerId, attendance) {
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          "bk-working": "update-attendance",
          playerId: playerId,
          attendance: attendance,
        }),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data["bk-result"] === true;
    } catch (error) {
      console.error("Update attendance failed:", error);
      throw error;
    }
  }

  receiveJSON(data) {
    if (data["bk-result"] === true) {
      const rawParticipants = data.participants || [];
      this.participants = rawParticipants.map((json) =>
        ParticipantData.fromJson(json)
      );
    } else {
      this.participants = [];
    }
  }
}
